// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select-user-type-container .join {
  font-size: 16px;
}
.select-user-type-container ul {
  display: flex;
  column-gap: 16px;
}
.select-user-type-container ul .choice {
  height: 200px;
  width: 156px;
  border-radius: 16px;
  padding: 24px 38px;
  background-color: #f9f9f9;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  position: relative;
  transition: 0.2s ease-in-out;
  cursor: pointer;
}
.select-user-type-container ul .choice > .check {
  position: absolute;
  top: 8px;
  right: 8px;
  height: 16px;
  width: 16px;
  border-radius: 100%;
  border: 3px solid #F3F3F3;
  background-color: #F3F3F3;
  transition: 0.2s ease-in-out;
}
.select-user-type-container ul .choice > p {
  margin-top: 52px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 700;
  color: #949494;
  white-space: nowrap;
  transition: 0.2s ease-in-out;
}
.select-user-type-container ul .choice.selected {
  background-color: #FEF7DE;
}
.select-user-type-container ul .choice.selected > p {
  color: var(--primary-color-1);
}
.select-user-type-container ul .choice.selected .check {
  background-color: var(--primary-color-1);
  border-color: white;
}
.select-user-type-container ul .choice:hover, .select-user-type-container ul .choice.active {
  background-color: #FEF7DE;
  border-color: var(--primary-color-1);
}
.select-user-type-container ul .choice span {
  font-size: 20px;
  font-weight: 700;
  color: var(--secondary-color-2);
}
.select-user-type-container button {
  width: 500px;
}

@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px) {
  .select-user-type-container {
    margin-bottom: 20px;
  }
  .select-user-type-container ul {
    row-gap: 16px;
    flex-wrap: wrap;
    justify-content: center;
  }
  .select-user-type-container ul .choice {
    flex: 50% 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/Authentication/modules/Signup/modules/SelectUserType/selectUserType.scss","webpack://./src/assets/styles/_mixins.scss"],"names":[],"mappings":"AAGI;EAAQ,eAAA;AADZ;AAEI;EACI,aAAA;EACA,gBAAA;AAAR;AACQ;EACI,aAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,4BAAA;EACA,eAAA;AACZ;AAAY;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,4BAAA;AAEhB;AAAY;EACI,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,4BAAA;AAEhB;AAAY;EACI,yBAAA;AAEhB;AADgB;EAAM,6BAAA;AAItB;AAHgB;EACI,wCAAA;EACA,mBAAA;AAKpB;AAFY;EACI,yBAAA;EACA,oCAAA;AAIhB;AAFY;EACI,eAAA;EACA,gBAAA;EACA,+BAAA;AAIhB;AAAI;EACI,YAAA;AAER;;AC3DY;ED+DR;IACI,mBAAA;EAAN;EACM;IACI,aAAA;IACA,eAAA;IACA,uBAAA;EACV;EAAU;IACI,WAAA;EAEd;AACF","sourcesContent":["@import 'assets/styles/_mixins.scss';\r\n\r\n.select-user-type-container {\r\n    .join { font-size: 16px; }\r\n    ul {\r\n        display: flex;\r\n        column-gap: 16px;\r\n        .choice {\r\n            height: 200px;\r\n            width: 156px;\r\n            border-radius: 16px;\r\n            padding: 24px 38px;\r\n            background-color: #f9f9f9;\r\n            display: flex;\r\n            flex-direction: column;\r\n            align-items: center;\r\n            justify-content: flex-end;\r\n            position: relative;\r\n            transition: .2s ease-in-out;\r\n            cursor: pointer;\r\n            > .check {\r\n                position: absolute;\r\n                top: 8px;\r\n                right: 8px;\r\n                height: 16px;\r\n                width: 16px;\r\n                border-radius: 100%;\r\n                border: 3px solid #F3F3F3;\r\n                background-color: #F3F3F3;\r\n                transition: .2s ease-in-out;\r\n            }\r\n            > p { \r\n                margin-top: 52px;\r\n                margin-bottom: 0;\r\n                font-size: 14px;\r\n                font-weight: 700;\r\n                color: #949494;\r\n                white-space: nowrap;\r\n                transition: .2s ease-in-out;\r\n            }\r\n            &.selected {\r\n                background-color: #FEF7DE;\r\n                > p { color: var(--primary-color-1); }\r\n                .check {\r\n                    background-color: var(--primary-color-1);\r\n                    border-color: white;\r\n                }\r\n            }\r\n            &:hover, &.active {\r\n                background-color: #FEF7DE;\r\n                border-color: var(--primary-color-1);\r\n            }\r\n            span {\r\n                font-size: 20px;\r\n                font-weight: 700;\r\n                color: var(--secondary-color-2);\r\n            }\r\n        }\r\n    }\r\n    button {\r\n        width: 500px;\r\n    }\r\n}\r\n\r\n\r\n@include media(mobile) {\r\n    .select-user-type-container {\r\n        margin-bottom: 20px;\r\n        ul {\r\n            row-gap: 16px;\r\n            flex-wrap: wrap;\r\n            justify-content: center;\r\n            .choice {\r\n                flex: 50%;\r\n            }\r\n        }\r\n    }\r\n}","@mixin media($keys...) {\r\n    @each $key in $keys {\r\n        @if ($key==mobile) {\r\n            @media (min-width: 481px) and (max-width: 767px),\r\n            (min-width: 320px) and (max-width: 480px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==tablet) {\r\n            @media (min-width: 768px) and (max-width: 1024px),\r\n            (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==nitty-gritt) {\r\n            @media (width: 1024px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==small-desktop) {\r\n            @media (max-width: 1440px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==desktop) {\r\n            @media (min-width: 1024px) and (max-width: 1440px) {\r\n                @content;\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
